import ChatWrapper from './ChatWrapper'

export default ChatWrapper
